import { useSelector, useDispatch } from "react-redux";
import { visualizerActions } from "../../store";
import { useState} from "react";
import styles from './FilterMenu.module.css';
import DropdownFilter from "../DropdownFilter/DropdownFilter";
import ProductSearch from "../ProductSearch/ProductSearch";
import CollectionFilter from "../CollectionFilter/CollectionFilter";
import toggleIcon from './assets/toggle.svg';


export default function FilterMenu({menuMode, setMenuMode}) {
    const dispatch = useDispatch();
    //used to wait 1/2 second until after user is done typing in search box
    const [typingTimeout, setTypingTimeout] = useState(null);
    //all filters currently applied
    const appliedDropdownFilters = useSelector(state => state.visualizer.productDropdownFilters);
    const appliedSearchFilters = useSelector(state => state.visualizer.productSearchFilters);
    //used to track and reset the current search value.
    const [searchValue, setSearchValue] = useState(""); 

    // Handle filter select
    const handleDropdownFilterChange = (e) => {
        const { name, value } = e.target;
        dispatch(visualizerActions.setproductDropdownFilter({
            [name]: value,
        }));
        setSearchValue('');
        dispatch(visualizerActions.clearProductSearchFilters());

    };


    const handleInput = (e) => {
        const columnNames = e.target.getAttribute('data-columns');
        let { name, value } = e.target;
        

        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        //TIMEOUT USED FOR KEYPRESS EVENT ON SEARCH INPUT
        //MAKES A DISPATCH CALL 1/2 SEC AFTER THE USER IS DONE TYPING
        //USED TO REDUCE THE NUMBER OF DISPATCH CALLS
        const timeoutId = setTimeout(() => {
            columnNames.split(',').forEach(column => {
                dispatch(visualizerActions.setProductSearchFilter({
                    [column]:value
                }));
            });

            //remove all applied filters that are associated with the dropdowns
            //this resets the dropdowns
            dispatch(visualizerActions.clearProductDropdownFilters(['categoryName']));

        }, 500); 

        

        setTypingTimeout(timeoutId);
    };

    return (
        <div className={styles.content}>
            <div className={styles.dropMenu}>

            <div className={styles.dropGroup}>
            <label>Series</label>
            <DropdownFilter
                handleSelect={handleDropdownFilterChange}
                seriesId="8552"
                label="Series"
                column="name"
                value={appliedDropdownFilters['name']??-1}
            />
            </div>


            <div className={styles.dropGroup}>
            <label>Species</label>
            <DropdownFilter
                handleSelect={handleDropdownFilterChange}
                seriesId="8552"
                label="Species"
                column="defaultRoomSceneSpecifier"
                value={appliedDropdownFilters['defaultRoomSceneSpecifier']??-1}
            />
            </div>

            <div className={styles.dropGroup}>    
            <label>Color</label>
            <DropdownFilter
                handleSelect={handleDropdownFilterChange}
                seriesId="8552"
                label="Colors"
                column="style"
                value={appliedDropdownFilters['style']??-1}
            />
            </div>

            <div className={styles.dropGroup}>
             <label>Texture</label>
            <DropdownFilter
                handleSelect={handleDropdownFilterChange}
                seriesId="8552"
                label="Textures"
                column="warranty"
                value={appliedDropdownFilters['warranty']??-1}
            />
             </div>

             <div className={styles.dropGroup}>
              <label>Plank Width</label>
            <DropdownFilter
                handleSelect={handleDropdownFilterChange}
                seriesId="8552"
                label="Plank Widths"
                column="thumbnailRenderOptions"
                value={appliedDropdownFilters['thumbnailRenderOptions']??-1}
            /></div>


             <div className={styles.dropGroup}>
             <label>Price Range</label>
            <DropdownFilter
                handleSelect={handleDropdownFilterChange}
                seriesId="8552"
                label="Price Ranges"
                column="ecoFriendly"
                value={appliedDropdownFilters['ecoFriendly']??-1}
            />
            </div>

            <div className={styles.searchGroup}>
            <label>Search by Color Name</label>
            <ProductSearch
                name="product search"
                columns="color"
                placeholder="Search by color name or ID"
                value={searchValue}
                handleInput={handleInput}
                onChange={(e) => setSearchValue(e.target.value)}
            />
            </div>
 
            {menuMode !== "fullMenu" && 
            
            <div className={styles.toggleBlock} onClick={() => {setMenuMode("fullMenu")}}>
                  <img src={toggleIcon} width="25px" height="25px" alt="Unlocked"/>
                </div>
            }
            


            </div>

            
        </div>
    );
}
